'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from '@/i18n/navigation';
import { LaunchCountdown } from './LaunchCountdown';

export function EarlyAccessPopup({ isLoggedIn }: { isLoggedIn: boolean }) {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (isLoggedIn) return;

		const lastShownStr = localStorage.getItem('earlyAccessPopupLastShown');
		const lastShown = lastShownStr ? parseInt(lastShownStr, 10) : 0;
		const now = Date.now();
		const TWELVE_HOURS = 12 * 60 * 60 * 1000;

		let timer: NodeJS.Timeout;

		if (now - lastShown > TWELVE_HOURS) {
			timer = setTimeout(() => {
				setIsOpen(true);
				localStorage.setItem('earlyAccessPopupLastShown', now.toString());
			}, 3000);
		}

		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [isLoggedIn]);

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 p-4 sm:p-6 backdrop-blur-sm animate-in fade-in duration-300">
			<div className="relative w-full max-w-lg rounded-3xl bg-white p-6 sm:p-10 shadow-2xl animate-in zoom-in-95 duration-300">
				
				<button 
					onClick={() => setIsOpen(false)}
					className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors"
					aria-label="Close popup"
				>
					<X className="size-5" />
				</button>

				<div className="text-center mt-2">
					<h2 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight mb-3">
						Enjoy 3 Months Free!
					</h2>
					
					<p className="text-slate-600 text-base sm:text-lg mb-2">
						Start generating premium dynamic QR codes today.
						<br className="hidden sm:block" /> No credit card required.
					</p>

					<LaunchCountdown />

					<div className="mt-8">
						<Button asChild size="lg" className="w-full h-14 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-lg rounded-xl shadow-md transition-all hover:shadow-lg hover:-translate-y-0.5">
							<Link href="/sign-up" onClick={() => setIsOpen(false)}>
								Claim My 3 Months Free
							</Link>
						</Button>
						<p className="text-xs text-slate-400 mt-4 font-medium">
							*The 90-day global free period ends January 6, 2027. Sign up now to maximize your free days!
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
